import { tagsConstants } from '../_constants';

//-- get the list of terms
export function getTagsList(state = {}, action) {
  switch (action.type) {
    case tagsConstants.TAGS_LIST_REQUEST:
      return {
        getTagsList: false
      };

    case tagsConstants.TAGS_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { isGetAdvertismentList: true, getTagsList: action.successAction };

    case tagsConstants.TAGS_LIST_FAILURE:
      return {
        getTagsList: false,
      };

    case tagsConstants.TAGS_SEARCH_REQUEST:
      return { isGetAdvertismentList: true, getTagsList: action.successAction.data };

    default:
      return state
  }
}

export function addTag(state = {}, action) {
  switch (action.type) {
    case tagsConstants.TAGS_ADD_REQUEST:
      return {
        addTag: false
      };

    case tagsConstants.TAGS_ADD_SUCCESS:
      return { addTag: action.successAction };

    case tagsConstants.TAGS_ADD_FAILURE:
      return {
        addTag: false,
      };

    default:
      return state
  }
}


export function deleteTag(state = {}, action) {
  switch (action.type) {
    case tagsConstants.TAGS_DELETE_REQUEST:
      return {
        deleteTag: false
      };

    case tagsConstants.TAGS_DELETE_SUCCESS:
      return { deleteTag: action.successAction };

    case tagsConstants.TAGS_DELETE_FAILURE:
      return {
        deleteTag: false,
      };

    default:
      return state
  }
}

export function allActiveTags(state = {}, action) {
  switch (action.type) {
    case tagsConstants.ACTIVE_TAGS_GET_REQUEST:
      return {
        activeTags: false
      };

    case tagsConstants.ACTIVE_TAGS_GET_SUCCESS:
      return { activeTags: action.successAction };

    case tagsConstants.ACTIVE_TAGS_GET_FAILURE:
      return {
        activeTags: false,
      };

    default:
      return state
  }
}